/* eslint-disable @typescript-eslint/return-await */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Backdrop } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import { useState } from "react";
import { useSelector } from "react-redux";

import { selectNewProfileAvatar } from "../../../store/newProfile/selector";
import { layoutPrivateStyle } from "../../../styles/layout/private-routes";
import { MobileMenuProps } from "../../../types/mobile-menu";
import { ModulProfileMenu } from "./modul-profile-menu";

export function Header({ mobileMenu, setMobileMenu }: MobileMenuProps) {
  const imageProfile = useSelector(selectNewProfileAvatar);
  const [profileMenu, setProfileMenu] = useState(false);

  return (
    <Stack component="header" sx={layoutPrivateStyle.header}>
      <Stack sx={layoutPrivateStyle.headerContainer}>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          sx={{ gap: { xs: "10px", sm: "16px" } }}
        >
          {/* image titik 9 */}
          <Box
            component="img"
            src="/assets/icon/semesta.svg"
            onClick={() => setMobileMenu?.(!mobileMenu)}
            sx={layoutPrivateStyle.headerIcon}
          />
          <Link
            href="/"
            sx={{ display: { xs: "none", sm: "flex", alignSelf: "center" } }}
          >
            {/* image atas kiri */}
            <Box
              component="img"
              src="/assets/logo/new-header-alesa.png"
              sx={layoutPrivateStyle.headerImg}
            />
          </Link>
        </Box>

        <Stack direction="row" alignItems="center" gap="16px">
          <Avatar
            src={imageProfile}
            sx={layoutPrivateStyle.headerAvatar}
            onClick={() => setProfileMenu?.(!profileMenu)}
          />
        </Stack>
        <Backdrop
          sx={{
            background: "transparent",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={profileMenu}
          onClick={() => setProfileMenu?.(!profileMenu)}
        >
          <Box
            sx={{
              width: { xs: "100%", xl: "1750px" },
              height: "100vh",
              position: "relative",
            }}
          >
            <ModulProfileMenu
              profileMenu={profileMenu}
              setProfileMenu={setProfileMenu}
            />
          </Box>
        </Backdrop>
      </Stack>
    </Stack>
  );
}
